const data = {
    module_name: "productos",
    title: "Productos",
    key: 'productos',
    category_key: "products",
    excel_key: "products"
}

module.exports = data